import { jwtDecode } from "jwt-decode";
import { nameLocal } from "./storage";
import axios from "axios";

export const isTokenValid = () => {
  const token = localStorage.getItem(nameLocal.token);

  if (!token) return false; // Pas de token, utilisateur non connecté

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000; // Timestamp actuel en secondes

    if (decoded.exp && decoded.exp < currentTime) {
      console.warn("Token expiré !");
      localStorage.removeItem(nameLocal.token);
      return false;
    }

    return true; // Token valide
  } catch (error) {
    console.error("Token invalide :", error);
    localStorage.removeItem(nameLocal.token);
    return false;
  }
};


export const infoUser = () => {
  const token = localStorage.getItem(nameLocal.token);
  try {
    const decoded = jwtDecode(token);
    return decoded
  } catch (error) {
    return null;
  }
}